import { z } from 'zod';
import { NullableJsonValue } from "../inputTypeSchemas/NullableJsonValue"

/////////////////////////////////////////
// DOCUMENTS TYPES SCHEMA
/////////////////////////////////////////

export const DocumentsTypesSchema = z.object({
  id: z.bigint(),
  city_id: z.number().int().nullable(),
  title: z.string(),
  data: NullableJsonValue.optional(),
  description: z.string().nullable(),
  signature_contact_info: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  form_fields_display: z.boolean(),
  qr_code_display: z.boolean().nullable(),
  qr_code_override_url: z.string().nullable(),
  is_public: z.boolean().nullable(),
  token: z.string().nullable(),
})

export type DocumentsTypes = z.infer<typeof DocumentsTypesSchema>

export default DocumentsTypesSchema;
